module.exports = __webpack_public_path__ + "img/603778.8bc99323.svg";